(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-ad-posters]').forEach(root => {
      if (root.dataset.postersReady) return;
      root.dataset.postersReady = 'true';
      const rail = root.querySelector('[data-poster-rail]');
      const cards = [...rail.querySelectorAll('[data-poster-card]')];
      const controls = root.querySelector('[data-poster-controls]');
      const previous = root.querySelector('[data-poster-prev]');
      const next = root.querySelector('[data-poster-next]');
      const dots = root.querySelector('[data-poster-dots]');
      if (!cards.length) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const desktopMouse = matchMedia('(min-width: 1024px)');
      const originalCursor = rail.style.cursor;
      const originalSelection = rail.style.userSelect;
      let drag = null, suppressClick = false;
      function interactionStyle() {
        const enabled = desktopMouse.matches && rail.scrollWidth > rail.clientWidth + 2;
        rail.style.cursor = drag?.moving ? 'grabbing' : enabled ? 'grab' : originalCursor;
        rail.style.userSelect = enabled ? 'none' : originalSelection;
      }
      function finishDrag(event) {
        if (!drag || (event?.pointerId !== undefined && event.pointerId !== drag.id)) return;
        const finished = drag;
        drag = null;
        if (finished.moving) {
          suppressClick = true;
          rail.style.scrollSnapType = finished.snap;
          rail.style.scrollBehavior = finished.behavior;
          if (rail.hasPointerCapture(finished.id)) rail.releasePointerCapture(finished.id);
        }
        interactionStyle();
      }
      rail.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (!desktopMouse.matches || event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || rail.scrollWidth <= rail.clientWidth + 2) return;
        drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, moving: false};
      });
      rail.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moving) {
          if (Math.abs(distance) < 6) return;
          if (Math.abs(event.clientY - drag.y) > Math.abs(distance)) {
            drag = null;
            return;
          }
          drag.moving = true;
          drag.snap = rail.style.scrollSnapType;
          drag.behavior = rail.style.scrollBehavior;
          rail.style.scrollSnapType = 'none';
          rail.style.scrollBehavior = 'auto';
          rail.setPointerCapture(drag.id);
          rail.scrollTo({left: drag.left, behavior: 'instant'});
          interactionStyle();
        }
        event.preventDefault();
        rail.scrollLeft = drag.left - distance;
      });
      window.addEventListener('pointerup', finishDrag);
      window.addEventListener('pointercancel', finishDrag);
      window.addEventListener('blur', () => finishDrag());
      rail.addEventListener('lostpointercapture', finishDrag);
      rail.addEventListener('dragstart', event => {
        if (desktopMouse.matches) event.preventDefault();
      });
      rail.addEventListener('click', event => {
        if (!suppressClick || event.detail === 0) return;
        suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      desktopMouse.addEventListener('change', () => {
        finishDrag();
        interactionStyle();
      });
      const sign = () => getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
      const positions = () => cards.map(card => (card.parentElement.offsetLeft - cards[0].parentElement.offsetLeft) * sign());
      let active = 0, queued = false;
      const move = index => {
        const target = Math.min(cards.length - 1, Math.max(0, index));
        rail.scrollTo({left: positions()[target] * sign(), behavior: motion.matches ? 'instant' : 'smooth'});
      };
      const step = delta => {
        const offset = Math.max(0, rail.scrollLeft * sign());
        const max = rail.scrollWidth - rail.clientWidth;
        const stops = [...new Set(positions().map(position => Math.min(position,max)))];
        const target = delta > 0 ? stops.find(position => position > offset + 2) ?? max : stops.findLast(position => position < offset - 2) ?? 0;
        rail.scrollTo({left: target * sign(), behavior: motion.matches ? 'instant' : 'smooth'});
      };
      const markers = cards.map((card, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-controls', rail.id);
        button.setAttribute('aria-label', dots.dataset.label.replace('__TITLE__',card.dataset.posterLabel));
        button.addEventListener('click', () => move(index));
        dots.append(button);
        return button;
      });
      function update() {
        queued = false;
        const max = Math.max(0,rail.scrollWidth - rail.clientWidth);
        const offset = Math.max(0,Math.min(max,rail.scrollLeft * sign()));
        controls.hidden = max < 2;
        rail.tabIndex = max > 2 ? 0 : -1;
        const starts = positions();
        active = starts.reduce((best,position,index) => Math.abs(Math.min(position,max)-offset) < Math.abs(Math.min(starts[best],max)-offset) ? index : best,0);
        if (offset >= max - 2) active = cards.length - 1;
        previous.disabled = offset < 2;
        next.disabled = offset >= max - 2;
        markers.forEach((button,index) => button.setAttribute('aria-current',String(index===active)));
        interactionStyle();
      }
      previous.addEventListener('click',() => step(-1));
      next.addEventListener('click',() => step(1));
      rail.addEventListener('scroll',() => {if (!queued) {queued=true;requestAnimationFrame(update)}},{passive:true});
      rail.addEventListener('keydown',event => {
        if (event.target!==rail) return;
        if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key==='Home') move(0);
        else if (event.key==='End') move(cards.length-1);
        else step(event.key==='ArrowRight' ? sign() : -sign());
      });
      rail.addEventListener('focusin',event => {
        const card=event.target.closest('[data-poster-card]');
        if (!card) return;
        const r=rail.getBoundingClientRect(),c=card.getBoundingClientRect();
        if (c.left < r.left-1 || c.right > r.right+1) card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      });
      new ResizeObserver(update).observe(rail);
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
